import DrawerMenuContext from "contexts/DrawerMenuContext";
import { useContext } from "react";

const useDrawerMenu = () => useContext(DrawerMenuContext);

export default useDrawerMenu;
